module.exports = __webpack_public_path__ + "img/send-order.ce37ec2f.svg";